/**
 * The FTUX's one door from eager code (blueprint section 2): MainLayout renders it while the `ftux` flag is on and
 * nobody is signed in as the owner, and it loads the layer (layer/FtuxRoot and everything under it, GSAP included) as
 * a chunk of its own. Nothing shows while it loads. A layer that cannot load (a stale chunk after a deploy, a dropped
 * connection) or throws shows nothing either: the studio carries on without the FTUX.
 *
 * Eager and import-light: React, the quiet boundary, and the layer only through the lazy import below.
 */
import React from 'react';

import { QuietBoundary } from '../QuietBoundary';

const FtuxRoot = React.lazy(() => import('./FtuxRoot'));

/** A layer that cannot load, or a session that throws, drops out on its own (QuietBoundary): its unmount puts the slice
 *  back to its start (no pick card, no paused nudges). A throw in the flow's own layer or in a probe is caught inside
 *  (FtuxRoot), the session going on. */
export const FtuxRootLazy = (): React.ReactElement => (
  <QuietBoundary>
    <React.Suspense fallback={null}>
      <FtuxRoot />
    </React.Suspense>
  </QuietBoundary>
);

export default FtuxRootLazy;
